export enum FortuneType {
	stock = 1,
	watchlist = 2,
	tag = 3,
}

export interface FortuneModel {
	order: number;
	type: FortuneType;
	title: string;
	description: string;
	value: string;
	img: string;
}

const list: FortuneModel[] = [
	{
		order: 1,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_1",
		description: "DAILY_FORTUNE_DESC_1",
		value: "AAPL",
		img: "/daily-fortune/01.png",
	},
	{
		order: 2,
		type: 2,
		title: "DAILY_FORTUNE_TITLE_2",
		description: "DAILY_FORTUNE_DESC_2",
		value: "6913077402977435717",
		img: "/daily-fortune/02.png",
	},
	{
		order: 3,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_3",
		description: "DAILY_FORTUNE_DESC_3",
		value: "SNAP",
		img: "/daily-fortune/03.png",
	},
	{
		order: 4,
		type: 2,
		title: "DAILY_FORTUNE_TITLE_4",
		description: "DAILY_FORTUNE_DESC_4",
		value: "6972766726295388226",
		img: "/daily-fortune/04.png",
	},
	{
		order: 5,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_5",
		description: "DAILY_FORTUNE_DESC_5",
		value: "EDU",
		img: "/daily-fortune/05.png",
	},
	{
		order: 6,
		type: 2,
		title: "DAILY_FORTUNE_TITLE_6",
		description: "DAILY_FORTUNE_DESC_6",
		value: "6913067182385528903",
		img: "/daily-fortune/06.png",
	},
	{
		order: 7,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_7",
		description: "DAILY_FORTUNE_DESC_7",
		value: "HSY",
		img: "/daily-fortune/07.png",
	},
	{
		order: 8,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_8",
		description: "DAILY_FORTUNE_DESC_8",
		value: "MSFT",
		img: "/daily-fortune/08.png",
	},
	{
		order: 9,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_9",
		description: "DAILY_FORTUNE_DESC_9",
		value: "WMG",
		img: "/daily-fortune/09.png",
	},
	{
		order: 10,
		type: 2,
		title: "DAILY_FORTUNE_TITLE_10",
		description: "DAILY_FORTUNE_DESC_10",
		value: "7052608551826802707",
		img: "/daily-fortune/10.png",
	},
	{
		order: 11,
		type: 3,
		title: "DAILY_FORTUNE_TITLE_11",
		description: "DAILY_FORTUNE_DESC_11",
		value: "7001786791653015626",
		img: "/daily-fortune/11.png",
	},
	{
		order: 12,
		type: 2,
		title: "DAILY_FORTUNE_TITLE_12",
		description: "DAILY_FORTUNE_DESC_12",
		value: "6972766726295388224",
		img: "/daily-fortune/12.png",
	},
	{
		order: 13,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_13",
		description: "DAILY_FORTUNE_DESC_13",
		value: "UNH",
		img: "/daily-fortune/13.png",
	},
	{
		order: 14,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_14",
		description: "DAILY_FORTUNE_DESC_14",
		value: "AZN",
		img: "/daily-fortune/14.png",
	},
	{
		order: 15,
		type: 2,
		title: "DAILY_FORTUNE_TITLE_15",
		description: "DAILY_FORTUNE_DESC_15",
		value: "6972766726295388224",
		img: "/daily-fortune/15.png",
	},
	{
		order: 16,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_16",
		description: "DAILY_FORTUNE_DESC_16",
		value: " HD",
		img: "/daily-fortune/16.png",
	},
	{
		order: 17,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_17",
		description: "DAILY_FORTUNE_DESC_17",
		value: "JNJ",
		img: "/daily-fortune/17.png",
	},
	{
		order: 18,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_18",
		description: "DAILY_FORTUNE_DESC_18",
		value: "NVDA",
		img: "/daily-fortune/18.png",
	},
	{
		order: 19,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_19",
		description: "DAILY_FORTUNE_DESC_19",
		value: "LVMUY",
		img: "/daily-fortune/19.png",
	},
	{
		order: 20,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_20",
		description: "DAILY_FORTUNE_DESC_20",
		value: "COLM",
		img: "/daily-fortune/20.png",
	},
	{
		order: 21,
		type: 2,
		title: "DAILY_FORTUNE_TITLE_21",
		description: "DAILY_FORTUNE_DESC_21",
		value: "7167722195639395610",
		img: "/daily-fortune/21.png",
	},
	{
		order: 22,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_22",
		description: "DAILY_FORTUNE_DESC_22",
		value: "KO",
		img: "/daily-fortune/22.png",
	},
	{
		order: 23,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_23",
		description: "DAILY_FORTUNE_DESC_23",
		value: "META",
		img: "/daily-fortune/23.png",
	},
	{
		order: 24,
		type: 2,
		title: "DAILY_FORTUNE_TITLE_24",
		description: "DAILY_FORTUNE_DESC_24",
		value: "6913067182385528920",
		img: "/daily-fortune/24.png",
	},
	{
		order: 25,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_25",
		description: "DAILY_FORTUNE_DESC_25",
		value: "BRK.B",
		img: "/daily-fortune/25.png",
	},
	{
		order: 26,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_26",
		description: "DAILY_FORTUNE_DESC_26",
		value: "U",
		img: "/daily-fortune/26.png",
	},
	{
		order: 27,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_27",
		description: "DAILY_FORTUNE_DESC_27",
		value: "TSLA",
		img: "/daily-fortune/27.png",
	},
	{
		order: 28,
		type: 2,
		title: "DAILY_FORTUNE_TITLE_28",
		description: "DAILY_FORTUNE_DESC_28",
		value: "6913067182385528921",
		img: "/daily-fortune/28.png",
	},
	{
		order: 29,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_29",
		description: "DAILY_FORTUNE_DESC_29",
		value: "RACE",
		img: "/daily-fortune/29.png",
	},
	{
		order: 30,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_30",
		description: "DAILY_FORTUNE_DESC_30",
		value: "DIS",
		img: "/daily-fortune/30.png",
	},
	{
		order: 31,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_31",
		description: "DAILY_FORTUNE_DESC_31",
		value: "NYT",
		img: "/daily-fortune/31.png",
	},
	{
		order: 32,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_32",
		description: "DAILY_FORTUNE_DESC_32",
		value: "LULU",
		img: "/daily-fortune/32.png",
	},
	{
		order: 33,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_33",
		description: "DAILY_FORTUNE_DESC_33",
		value: "GOOG",
		img: "/daily-fortune/33.png",
	},
	{
		order: 34,
		type: 1,
		title: "DAILY_FORTUNE_TITLE_34",
		description: "DAILY_FORTUNE_DESC_34",
		value: "PFE",
		img: "/daily-fortune/34.png",
	},
];

const devList = () => {
	const devWatchListId = "6913077402977435726";
	const devStock = "AAPL";
	const devTagId = "7001786791653015626";

	return list.map((item) => {
		let value: string = "";
		if (item.type === FortuneType.stock) {
			value = devStock;
		} else if (item.type === FortuneType.tag) {
			value = devTagId;
		} else {
			value = devWatchListId;
		}

		return {
			...item,
			value,
		};
	});
};

export default function getDataSource(order: number) {
	const isTestEnv = process.env.NEXT_PUBLIC_APP_ENV !== "production";
	if (isTestEnv) {
		return devList().find((item) => item.order === order);
	}
	return list.find((item) => item.order === order);
}

const FORTUNE = ["大吉", "上吉", "中吉", "吉", "小吉", "末吉"];
export function getFortune(order: number) {
	return FORTUNE[order % 6];
}
